<ui-modal
  [title]="modalTitle"
  description="Заполните все поля"
  [loading]="isLoadingData"
  (afterClose)="onAfterClose()"
  width="900px"
  height="600px"
>
  <ui-form [form]="form" [config]="formConfig"></ui-form>

  <ui-form [form]="formLocation" [config]="formLocationConfig"></ui-form>

  <!-- <h2 class="font-bold text-[20px]">Координаты площади:</h2>
  <div *ngFor="let coordinateForm of formLocationArray; let i = index">
    <h4 class="font-semibold mb-2">
      {{ coordinateForm.get('label')?.value }}
    </h4>
    <ui-form [form]="coordinateForm" [config]="formCoordinateConfig"></ui-form>
  </div> -->

  <div class="flex justify-start">
    <ui-button type="primary" size="small" (click)="onOpenMapModal()">
      <ui-icon name="environment" size="20px"></ui-icon>
      <span>Показать на карте</span>
    </ui-button>
  </div>
</ui-modal>

<ng-template #footerRef>
  <ui-button
    type="primary"
    [block]="true"
    [loading]="isSaving"
    [disabled]="canNotSave"
    (click)="onSave()"
  >
    @if (isDetails) {
    <ui-icon name="save" size="20px"></ui-icon>
    <span>Сохранить</span>
    } @else {
    <ui-icon name="plus" size="20px"></ui-icon>
    <span>Добавить</span>
    }
  </ui-button>
</ng-template>
